import React from 'react';
import { useWeather } from '../../context';
import { TimeSeriesChart } from './TimeSeriesChart';
import { StormReportDetails } from './StormReportDetails';
import { WildfireDetails } from './WildfireDetails';
import { DroughtAnalytics } from './DroughtAnalytics';

export function AnalyticsPanel() {
  const { 
    weatherData, 
    loading, 
    modelSelect, 
    parameterSelect,
    selectedReport,
    loadingProgress 
  } = useWeather();

  if (loading) {
    return (
      <div className="h-64 glass-panel m-4">
        <div className="flex flex-col items-center justify-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--accent-color)] mb-4"></div>
          {loadingProgress && (
            <div className="text-[var(--secondary-text)]">
              Loading squares: {loadingProgress.current} / {loadingProgress.total}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (!weatherData || weatherData.length === 0) {
    return (
      <div className="h-64 glass-panel m-4">
        <div className="flex items-center justify-center h-full text-[var(--secondary-text)]">
          No data available. Select an area and fetch data to begin.
        </div>
      </div>
    );
  }

  if (modelSelect === 'drought') {
    return <DroughtAnalytics />;
  }

  if (modelSelect === 'wildfire') {
    return (
      <div className="h-64 glass-panel m-4 p-4">
        <WildfireDetails fires={weatherData} />
      </div>
    );
  }

  if (modelSelect === 'xweather') {
    return (
      <div className="h-64 glass-panel m-4 p-4">
        {selectedReport ? (
          <StormReportDetails report={selectedReport} />
        ) : (
          <div className="text-[var(--secondary-text)] text-center">
            Click a storm report on the map to view details
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="h-64 glass-panel m-4 p-4">
      <TimeSeriesChart data={weatherData} parameter={parameterSelect} />
    </div>
  );
}